import { apiGet, apiPatch } from './client';
import type {
  BankAccount,
  BankAccountBatchRequest,
} from '../types/BankAccount';

export function getBankAccounts(): Promise<BankAccount[]> {
  return apiGet<BankAccount[]>('/api/bank-accounts');
}

export function saveBatchBankAccounts(
  added: BankAccount[],
  modified: BankAccount[],
  deletedIds: string[],
): Promise<BankAccount[]> {
  // BankAccountCreate / BankAccountUpdate are structurally identical to
  // BankAccount, so we can pass the full rows directly (no field stripping).
  // No date fields to normalize.
  return apiPatch<BankAccountBatchRequest, BankAccount[]>(
    '/api/bank-accounts/batch',
    { added, modified, deleted: deletedIds },
  );
}
